define('modules/lp_integration/models/integration_correodirect',['require','exports','module','backbone','env'],function(require, exports, module){
  "use strict";
  var Backbone = require("backbone"),
      config = require("env");
  module.exports = Backbone.Model.extend({
    defaults: {
      active: false,
      idaf: "",
      fields: {}
    },
    url: function(){
      return [config.apiHost, "pages", this.pageId, "integration", "correodirect"].join("/");
    },
    initialize: function(attrs,options){
      this.pageId = options.pageId;
    },
    toJSON: function(){
      return _.omit(module.exports.__super__.toJSON.apply(this), "id");
    },
    validate: function(attrs,options){
      var errors = [];
      if (!attrs.idaf){
        errors.push({
          attribute: "idaf"
        });
      }

      if(_.isEmpty(attrs.fields)){
        errors.push({
          attribute: "fields"
        });
      }

      if(errors.length){
        this.set("active",false);
        return errors;
      }
    },
    isEmpty: function(){
      return !this.get("url") && _.isEmpty(this.get("fields"));
    },

  });
});

